import { render, staticRenderFns } from "./FunctinalityDetailsTab.vue?vue&type=template&id=73e63163&"
import script from "./FunctinalityDetailsTab.vue?vue&type=script&lang=js&"
export * from "./FunctinalityDetailsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports